/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const CMSDeleteIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="CMSDeleteIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 2C9.31121 2 10.5231 2.294 11.4248 2.79492C12.3096 3.28647 13 4.04561 13 5V8H12V6.82129C11.8224 6.96255 11.6292 7.0915 11.4248 7.20508C10.5231 7.706 9.31121 8 8 8C6.68879 8 5.4769 7.706 4.5752 7.20508C4.37076 7.0915 4.17756 6.96255 4 6.82129V8C4 8.42631 4.31669 8.91778 5.06055 9.33105C5.78751 9.73492 6.82597 10 8 10V11C6.68879 11 5.4769 10.706 4.5752 10.2051C4.37076 10.0915 4.17756 9.96255 4 9.82129V11C4 11.4263 4.31669 11.9178 5.06055 12.3311C5.78751 12.7349 6.82597 13 8 13V14C6.68879 14 5.4769 13.706 4.5752 13.2051C3.69042 12.7135 3 11.9544 3 11V5C3 4.04561 3.69042 3.28647 4.5752 2.79492C5.4769 2.294 6.68879 2 8 2ZM8 3C6.82597 3 5.78751 3.26508 5.06055 3.66895C4.31669 4.08222 4 4.57369 4 5C4 5.42631 4.31669 5.91778 5.06055 6.33105C5.78751 6.73492 6.82597 7 8 7C9.17403 7 10.2125 6.73492 10.9395 6.33105C11.6833 5.91778 12 5.42631 12 5C12 4.57369 11.6833 4.08222 10.9395 3.66895C10.2125 3.26508 9.17403 3 8 3Z"
                fill="currentColor"
              />
              <path
                d="M13.8535 9.85352L12.207 11.5L13.8535 13.1465L13.1465 13.8535L11.5 12.207L9.85352 13.8535L9.14648 13.1465L10.793 11.5L9.14648 9.85352L9.85352 9.14648L11.5 10.793L13.1465 9.14648L13.8535 9.85352Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

CMSDeleteIcon.tags = ['collection', 'coins', 'stack', 'remove', 'cancel'];

CMSDeleteIcon.category = 'General Icons';

CMSDeleteIcon.iconSize = 16;
